import fetch from '../fetch';

const path = process.env.VUE_APP_STATISTICS_SERVER_URL;
const devicePath = process.env.VUE_APP_DEVICE_SERVER_URL;

export const fetchConsumeList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryConsumeList',
    method: 'POST',
    timeout: 30000,
    ...req,
  });
export const fetchReportList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryReportList',
    ...req,
  });
export const fetchTitleList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryTitleList',
    ...req,
  });
export const getRechargeOrderList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryRechargeOrderList',
    method: 'POST',
    ...req,
  });
export const getConsumeOrderList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryConsumeOrderList',
    method: 'POST',
    ...req,
  });
export const getFeedbackList = req =>
  fetch({
    url: path + '/dcxy/reportInfo/queryFeedbackList',
    ...req,
  });
export const getWarnningCount = req =>
  fetch({
    url: devicePath + '/device/warning/count',
    noErrorAlert: true,
    ...req,
  });

export const getTips = req =>
  fetch({
    url:devicePath+'/deviceServiceFees/operators/fee/prompting',
    method:'GET',
  })
//获取当日储值和消费金额
export const getChuzhiCustomMoney = req =>
  fetch({
    url: path + '/home/view/currentDayRechargeAndConsume',
    noErrorAlert: true,
    ...req,
  });
//获取储值消费记录
export const getChuzhiCustomRecord = req =>
  fetch({
    url: path + '/home/view/rechargeAndConsumeRecord',
    noErrorAlert: true,
    ...req,
  });
//获取月度注册人数
export const getRegisters = req =>
  fetch({
    url: path + '/home/view/monthlyRegistrations',
    noErrorAlert: true,
    ...req,
  });
//获取月度活跃
export const getActiveMembers = req =>
  fetch({
    url: path + '/home/view/monthlyActivityNumber',
    noErrorAlert: true,
    ...req,
  });
//获取设备分布
export const getDeviceLocations = req =>
  fetch({
    url: path + '/home/view/EquipmentDistributionMap',
    noErrorAlert: true,
    ...req,
  });
//获取连续12个月消费记录
export const get12MonthsCustom = req =>
  fetch({
    url: path + '/home/view/consumebymonth',
    noErrorAlert: true,
    ...req,
  });
//获取服务消费数据
export const getServiceCustom = req =>
  fetch({
    url: path + '/home/view/consumebyservice',
    noErrorAlert: true,
    ...req,
  });
//获取总览
export const getFirstAreaData = req =>
  fetch({
    url: path + '/home/view/usersareasmoneystotal',
    noErrorAlert: true,
    ...req,
  });
export const getOnlineDeviceNum = req =>
  fetch({
    url: devicePath + '/device/report/deviceAmount/online',
    noErrorAlert: true,
    ...req,
  });
export const getSevenConsumeDatas = req =>
  fetch({
    url: path + '/home/view/consumebyday',
    noErrorAlert: true,
    ...req,
  });
  